import FingerprintJS from '@fingerprintjs/fingerprintjs';
import {
  browserName,
  browserVersion,
  osName,
  osVersion,
  deviceType,
  isMobile,
} from 'react-device-detect';
import axios from 'axios';

export const getDeviceInfo = async () => {
  const deviceInfo = {
    ipAddress: null,
    browserId: null,
    browserName,
    browserVersion,
    osName,
    osVersion,
    deviceType,
    isMobile,
    latitude: null,
    longitude: null,
    location: null, // city/state/country
  };

  try {
    // Get IP address
    const ipRes = await fetch('https://api.ipify.org?format=json');
    const ipData = await ipRes.json();
    deviceInfo.ipAddress = ipData.ip;

    // Get browser fingerprint
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    deviceInfo.browserId = result.visitorId;

    // Get geolocation
    const getLocation = () =>
      new Promise((resolve, reject) => {
        if ('geolocation' in navigator) {
          navigator.geolocation.getCurrentPosition(resolve, reject);
        } else {
          reject(new Error('Geolocation not supported'));
        }
      });

    const position = await getLocation();
    deviceInfo.latitude = position.coords.latitude;
    deviceInfo.longitude = position.coords.longitude;

    // Reverse geocode location (using OpenStreetMap)
    const url = `https://nominatim.openstreetmap.org/reverse?lat=${deviceInfo.latitude}&lon=${deviceInfo.longitude}&format=json&addressdetails=1`;
    const response = await axios.get(url);

    if (response.data && response.data.address) {
      const { city, state, country } = response.data.address;
      const parts = [city, state, country].filter(Boolean); // remove undefined/null
      deviceInfo.location = parts.join(', ');
    } else {
      console.warn('Location not found in response.');
    }
  } catch (error) {
    console.error('Error collecting device info:', error);
  }




  const loginData = {
    machineId:deviceInfo.browserId,
    deviceName:deviceInfo.osName,
    appType: "WEBAPP",
    ip: deviceInfo.ipAddress,
    browser: deviceInfo.browserName,
    location:deviceInfo.location
  };

  return loginData;

};
